<template>
  <div class="container" style="margin-top: 15%">
    <div class="mt-3 alert alert-danger" v-if="showError" id="error">Username or Password is incorrect</div>
    <div class="card" style="margin: 0 30% 0 30%">
      <div class="card-header">Login to this System</div>
      <div class="card-body">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">@</span>
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            aria-label="Username"
            v-model="form.username"
            aria-describedby="basic-addon1"
          />
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">#</span>
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            aria-label="Password"
            v-model="form.password"
            aria-describedby="basic-addon1"
          />
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-success btn-sm float-right" @click="login">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@services/AuthService";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      showError: false,
    };
  },
  methods: {
    async login() {
      try {
        const result = await AuthService.login({
          username: this.form.username,
          password: this.form.password,
        });
        if (result) {
          this.$router.push("/report");
          this.showError = false;
        } else {
          this.showError = true;
        }
      } catch (error) {
        console.log(error);
        this.showError = true;
      }
    },
  },
};
</script>
